import { render } from "./DriverDetail.vue?vue&type=template&id=c453aa06"
import script from "./DriverDetail.vue?vue&type=script&lang=js"
export * from "./DriverDetail.vue?vue&type=script&lang=js"

import "./DriverDetail.vue?vue&type=style&index=0&id=c453aa06&lang=css"
script.render = render

export default script